import React, { Component, useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import propTypes from 'prop-types'
import { fetchNewHomeMenus } from '../../actions/newHome'
import searchIcon from 'images/magnf_glass.svg'
import clearIcon from 'images/clear_icon.svg'
import NewHomeQuickAccessCard from 'component/NewHomeQuickAccessCard/NewHomeQuickAccessCard'
import Modal from 'component/Modal/GenericModal'
import Checkbox from 'component/Checkbox/newCheckbox'
import AccordionDropdown from 'component/utils/Accordion'
import './newHome.css'
import * as menuActions from '../../actions/menu'
import { browserHistory } from 'react-router'
import Badge from 'component/Badge'

const ActivityIndicator = () => (
  <div className='lds-spinner'>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
)

const debounce = (func, wait) => {
  let timeout

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }

    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

const QuickAccessCard = connect((state) => ({
  menu: state.menuReducer.menu,
}))(
  ({
    t,
    menu: availableMenus = {},
    selectedMenus = [],
    cdMenu: currentCdMenu,
    onSave,
    onRemove,
    setSelectedItem
  }) => {
    const [isEditing, setIsEditing] = useState(false)
    const [openAccordion, setOpenAccordion] = useState()
    const [totals, setTotals] = useState({})
    const [selected, setSelected] = useState(selectedMenus)
    const overallTotal = Object.values(totals).reduce(
      (reduced, item) => reduced + item.length,
      0
    )
    const currentMenu = Object.values(availableMenus)
      .reduce(
        (reduced, item) => [
          ...reduced,
          ...(item.subItems || []).map((itemContent) => ({
            ...itemContent,
            nmImage: item.nmImage,
          })),
        ],
        []
      )
      .find(({ cdMenu }) => cdMenu === currentCdMenu)

    const isSubChecked = (cdMenu, cdSub) =>
      totals[cdMenu] && totals[cdMenu].indexOf(cdSub) > -1

    const toggleMenu = (cdMenu, cdSub) => {
      let newTotals = totals
      if (isSubChecked(cdMenu, cdSub)) {
        newTotals = {
          ...totals,
          [cdMenu]: totals[cdMenu].filter((i) => i !== cdSub),
        }
      } else if (overallTotal < 4) {
        newTotals = {
          ...totals,
          [cdMenu]: [...(totals[cdMenu] || []), cdSub],
        }
      }

      const selected = Object.values(newTotals).reduce(
        (reduced, item) => [...reduced, ...item],
        []
      )

      setIsEditing(true)
      setTotals(newTotals)
      setSelected(selected)
    }

    const openDsView = () => {
      let { dsView } = currentMenu


      if (dsView) {
        if (!dsView.startsWith('/')) {
          dsView = `/${dsView}`
        }
        setSelectedItem({ cdMenu: currentMenu.cdMenuParent, cdSubItem: currentMenu.cdMenu })
        browserHistory.push(dsView)
      }
    }

    const getBadge = (cdMenu) =>
      totals[cdMenu] &&
      totals[cdMenu].length &&
      String(totals[cdMenu].length).padStart(2, '0')

    useEffect(() => {
      if (!isEditing) {
        setTotals(
          Object.values(availableMenus).reduce(
            (reduced, item) => ({
              ...reduced,
              [item.cdMenu]: (item.subItems || []).reduce(
                (subreduced, { cdMenu }) => {
                  if (selectedMenus.indexOf(cdMenu) > -1) {
                    return [...subreduced, cdMenu]
                  }
                  return subreduced
                },
                []
              ),
            }),
            {}
          )
        )
      }
    }, [isEditing, setTotals, availableMenus, selectedMenus])

    return (
      <Modal
        title={t('new.home.quickAccess.title')}
        buttonText=''
        isConfirmButtonDisabled={overallTotal === 0}
        cancelButtonText={t('close_button_label')}
        confirmButtonText={t('new.home.quickAccess.add')}
        onConfirm={() => {
          setIsEditing(false)
          onSave && onSave(selected)
        }}
        onCloseModal={() => setIsEditing(false)}
        renderButton={({ onClick }) => (
          <NewHomeQuickAccessCard
            t={t}
            title={
              currentMenu
                ? t(currentMenu.dsChaveMenu)
                : t('new.home.quickAccess.addQuickAccess')
            }
            onClick={currentCdMenu ? openDsView : onClick}
            isFilled={!!currentCdMenu}
            iconName={currentMenu && currentMenu.nmImage}
            onRemove={() => {
              setIsEditing(false)
              onRemove && onRemove()
            }}
          />
        )}
      >
        <div style={{ width: '100%' }}>
          {t('new.home.quickAccess.description')}
          {Object.values(availableMenus).map(
            ({ dsChaveMenu, subItems, cdMenu }) => (
              <AccordionDropdown
                key={`accordion-menu-selector-${cdMenu}`}
                isOpen={openAccordion === cdMenu}
                onChange={(isOpen) =>
                  isOpen ? setOpenAccordion(cdMenu) : setOpenAccordion(null)
                }
                title={
                  <div className='w-100'>
                    <span className='home-accordion-title'>{t(dsChaveMenu)}</span>
                    {!!getBadge(cdMenu) && <Badge text={getBadge(cdMenu)} className='accordion-badge' badgeType='success' />}
                  </div>
                }
                badge={() => getBadge(cdMenu)}
                contentClassName='quick-access-checkbox-content'
                className='margin-top-small no-margin-bottom'
                size='sm'
              >
                {subItems.map(({ dsChaveMenu: subChave, cdMenu: cdSub }, k) => (
                  <Checkbox
                    key={k}
                    disabled={
                      overallTotal === 4 && !isSubChecked(cdMenu, cdSub)
                    }
                    name='checkbox1'
                    label={t(subChave)}
                    checked={isSubChecked(cdMenu, cdSub)}
                    onChange={() => toggleMenu(cdMenu, cdSub)}
                  />
                ))}
              </AccordionDropdown>
            )
          )}
        </div>
      </Modal>
    )
  }
)

class NewHome extends Component {
  constructor(props) {
    super(props)
    this.handleMenuSearch = debounce(this.handleMenuSearch, 500)
    this.state = {
      query: '',
      quickAccessMenu: null,
    }
  }

  componentDidMount() {
    const { user, dispatch } = this.props

    if (user) {
      menuActions
        .fetchQuickAccess(
          user.dsToken,
          user.username,
          user.title
        )(dispatch)
        .then(
          ({ data }) => {
            this.setState({
              quickAccessMenu: (data || []).map(({ cdMenu }) => cdMenu),
            })
          },
          () => {
            this.setState({
              quickAccessMenu: [],
            })
          }
        )
    }
  }

  handleFieldChange = (query) => {
    this.setState({ query })
    this.handleMenuSearch(query)
  }

  handleMenuSearch = (query) => {
    const { fetchNewHomeMenus, user } = this.props
    fetchNewHomeMenus(user.title, user.username, query, user.dsToken)
  }

  handleClear = () => {
    this.setState({ query: '' })
  }

  handleSaveQuickAccess = (selected) => {
    const { user, dispatch } = this.props
    this.setState(
      {
        quickAccessMenu: selected,
      },
      () => {
        menuActions
          .saveQuickAccess(
            user.dsToken,
            user.username,
            selected
          )(dispatch)
          .then(console.log, console.error)
      }
    )
  }

  render() {
    const { t, menus, loading, allMenus, setSelectedItem } = this.props
    const { query, quickAccessMenu } = this.state

    return (
      <div className='new-home'>
        <div className='home-search-container'>
          <div className='home-title'>
            <span>{t('new.home.title')}</span>
          </div>
          <div className='home-gradient'>
            <h3>{t('new.home.searching.func')}</h3>

            <div>
              <img src={searchIcon} className='search-icon' />

              <input
                value={query}
                placeholder={t('search.here')}
                className={query ? 'remove-border' : ''}
                onChange={(e) => this.handleFieldChange(e.target.value)}
              />

              {query && (
                <div className='round-icon'>
                  <img
                    src={clearIcon}
                    className='clear-icon'
                    onClick={() => this.handleClear()}
                  />
                </div>
              )}
            </div>
          </div>

          <div className='search-results'>
            <h3>{t('new.home.quickAccess.title')}</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {(quickAccessMenu || []).map((quickAccessMenuCd, k) => (
                <QuickAccessCard
                  key={k}
                  t={t}
                  cdMenu={quickAccessMenuCd}
                  onSave={this.handleSaveQuickAccess}
                  onRemove={() =>
                    this.handleSaveQuickAccess(
                      quickAccessMenu.filter((i) => i !== quickAccessMenuCd)
                    )
                  }
                  selectedMenus={quickAccessMenu}
                  setSelectedItem={setSelectedItem}
                />
              ))}
              {!!quickAccessMenu && quickAccessMenu.length < 4 && (
                <QuickAccessCard
                  t={t}
                  cdMenu={null}
                  onSave={this.handleSaveQuickAccess}
                  selectedMenus={quickAccessMenu}
                />
              )}
            </div>
          </div>

          {(query && menus && !menus.error && menus.length && (
            <div className='search-results'>
              <h3>{t('new.home.search.results')}</h3>
              <div className='results-container'>
                {loading && (
                  <div className='spinner-container'>
                    <ActivityIndicator />
                  </div>
                )}

                {(menus || []).map((menu, k) => {
                  if (!menu.dsView) return null
                  const parent =
                    allMenus && allMenus[menu.cdMenuParent]
                      ? t(allMenus[menu.cdMenuParent].dsChaveMenu)
                      : false
                  return (
                    <a key={k} href={menu.dsView}>
                      {parent ? (
                        <span className='parent-menu'>{parent}/</span>
                      ) : (
                        ''
                      )}
                      <span className='menu-name'>{t(menu.dsChaveMenu)}</span>
                    </a>
                  )
                })}
              </div>
            </div>
          )) ||
            (query && (
              <div className='search-results'>
                <h3>{t('new.home.no.results')}</h3>
              </div>
            )) ||
            null}
        </div>
      </div>
    )
  }
}

NewHome.propTypes = {
  user: propTypes.object,
  fetchNewHomeMenus: propTypes.func,
  t: propTypes.func,
  dispatch: propTypes.func,
  menus: propTypes.object,
  loading: propTypes.bool,
  allMenus: propTypes.object,
  setSelectedItem: propTypes.func
}

const NewHomeTranslated = translate(null, {
  wait: true,
  translateFuncName: 't',
})(NewHome)

const mapStateToProps = (state) => ({
  menus: state.menuReducer.menuFilters,
  user: state.auth.user,
  loading: state.menuReducer.menuFiltersLoading,
  allMenus: state.menuReducer.menu,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSelectedItem: menuActions.setSelectedItem,
      fetchNewHomeMenus,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(NewHomeTranslated)
